import { useState } from 'react';
import PropTypes from 'prop-types';

import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import {
  dialogContentCompactGapClassName,
} from '#/modules/commonComponents/dialog/dialogLayoutTokens';
import FloatingTextarea from '#/modules/commonComponents/form/FloatingTextarea';

/**
 * 結案 Dialog 開啟時掛載，state 自然重置。
 */
const CloseDialogSession = ({
  open,
  onOpenChange,
  isPending,
  onConfirm,
}) => {
  const [closeReason, setCloseReason] = useState('');

  function handleCancel() {
    onOpenChange(false);
  }

  function handleConfirm() {
    if (isPending) {
      return;
    }
    onConfirm?.({
      closeReason: closeReason.trim() || null,
    });
  }

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="結案客戶訂單"
      description="結案條件：各產品已收款（PAID）銷貨量累計達訂購量減取消量。送達量與配件短缺不阻擋結案。"
      headerVariant="muted"
      contentClassName={dialogContentCompactGapClassName}
      closeOnOutsideClick={false}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      confirmText={isPending ? '結案中…' : '結案'}
      confirmDisabled={isPending}
      cancelText="取消"
    >
      <div className="space-y-3 pt-2.5">
        <FloatingTextarea
          id="customer-order-close-reason"
          label="結案原因（可選）"
          value={closeReason}
          onChange={(event) => setCloseReason(event.target.value)}
          rows={3}
        />
      </div>
    </AppDialog>
  );
};

CloseDialogSession.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  isPending: PropTypes.bool,
  onConfirm: PropTypes.func,
};

/**
 * 結案 Dialog：closeReason 可選。
 */
const CustomerOrderCloseDialog = ({
  open,
  onOpenChange,
  isPending = false,
  onConfirm,
}) => {
  if (!open) {
    return (
      <AppDialog
        open={false}
        onOpenChange={onOpenChange}
        title="結案客戶訂單"
        description="結案條件：各產品已收款（PAID）銷貨量累計達訂購量減取消量。"
        headerVariant="muted"
      />
    );
  }

  return (
    <CloseDialogSession
      open={open}
      onOpenChange={onOpenChange}
      isPending={isPending}
      onConfirm={onConfirm}
    />
  );
};

CustomerOrderCloseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  isPending: PropTypes.bool,
  onConfirm: PropTypes.func,
};

export default CustomerOrderCloseDialog;
